export default "__VITE_ASSET__Y1TORMzp__"